export default __webpack_public_path__ + "static/B0166-07c2531fcba1e10a925967d3f8391a7c.png";